import type * as Pdfjs from 'pdfjs-dist/types/src/pdf';

export function calculateOptimalPdfPageScaling(page: Pdfjs.PDFPageProxy, width: number, height: number): number {
    const defaultViewport = page.getViewport({scale: 1});
    return Math.min(width / defaultViewport.width, height / defaultViewport.height);
}